import {UtilityService} from '../service/utility.service';

/**
 * @class
 * @description This model contains the properties of a PrismHR PEO.
 * @export
 * @name PeoApiModel
 */
export class PeoApiModel {

  /**
   * @default UtilityService.DateTimeUtc()
   * @description This property contains timestamp at which the PrismHR PEO was created in the SyncStream system.
   * @memberof PeoApiModel
   * @name PeoApiModel#created
   * @property
   * @public
   * @type {Date}
   */
  public created: Date = UtilityService.DateTimeUtc();

  /**
   * @description This property contains the name of the PEO.
   * @memberof PeoApiModel
   * @name PeoApiModel#name
   * @property
   * @public
   * @type {string}
   */
  public name!: string;

  /**
   * @description This property contains the unique identifier of the PEO in the PrismHR system.
   * @memberof PeoApiModel
   * @name PeoApiModel#peoId
   * @property
   * @public
   * @type {string}
   */
  public peoId!: string;

  /**
   * @default UtilityService.DateTimeUtc()
   * @description This property contains timestamp at which the PrismHR PEO was last updated in the SyncStream system.
   * @memberof PeoApiModel
   * @name PeoApiModel#updated
   * @property
   * @public
   * @type {Date}
   */
  public updated: Date = UtilityService.DateTimeUtc();
}
